import type { TranslationFnc } from '~/_shared/utils/hooks';
import { MapKeyType } from './masterKey.types';

export const getMapKeyTypeDisplayName = (mapKey: MapKeyType, t: TranslationFnc): string => {
  switch (mapKey) {
    case MapKeyType.LocationList:
      return t('Location List');
    case MapKeyType.MasterKey:
    default:
      return t('Master Key');
  }
};
